import { useMemo } from "react";
import promiseWrapper from "../utils/promiseWrapper";
import Resources from "../utils/Resources";
const getMessages = ({ resources, locale, id }) => {
  const resourcesInstance = new Resources(resources);
  if (typeof window === "undefined" || !(window.translations && window.translations[id] && window.translations[id].locale === locale)) {
    const promiseFn = resourcesInstance.get(locale);
    return promiseWrapper({ locale, id, promiseFn });
  }
  return {
    hydrated: true,
    read() {
      return window.translations[id].messages;
    }
  };
};
const useGetMessages = ({ id, locale, resources }) => {
  const messages = useMemo(() => {
    return getMessages({ resources, locale, id });
  }, [resources, id, locale]);
  return messages;
};
var useGetMessages_default = useGetMessages;
export {
  useGetMessages_default as default
};
